<template>
	<v-container class="py-5">
		<v-row class="d-flex justify-center">
			<v-col cols="12" class="d-flex justify-center"> <v-divider></v-divider> </v-col>

			<v-col cols="12" class="d-flex justify-center">
				<h4 class="font-weight-medium text-center">{{ $t('paymentmanager.orderConfirm') }}.</h4>
			</v-col>
			<v-col cols="12" class="d-flex justify-center">
				<h4 class="font-weight-medium text-center">{{ $t('paymentmanager.gatewayinfo') }}</h4>
			</v-col>

			<v-col cols="12" class="d-flex justify-center"> <v-divider></v-divider> </v-col>

			<v-col cols="6" class="d-flex justify-center">
				<v-btn outlined color="#868c8d" @click="handlePayment"
					><span class="font-weight-medium fcolor-extra-dark">{{ $t('paymentmanager.processpayment') }}</span></v-btn
				>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	methods: {
		handlePayment() {
			this.$emit('handlePayment');
		}
	}
};
</script>

<style></style>
